import 'css-chunksrc/client/pages/projectPage/kanbanPage/statusCreationForm/form/styles.scss';export default {
  "form": "_form_1h0xy_1",
  "row": "_row_1h0xy_13",
  "iconBox": "_iconBox_1h0xy_22",
  "icon": "_icon_1h0xy_22",
  "input": "_input_1h0xy_38",
  "label": "_label_1h0xy_55",
  "warning": "_warning_1h0xy_60",
  "completionInput": "_completionInput_1h0xy_66",
  "colorPicker": "_colorPicker_1h0xy_85",
  "button": "_button_1h0xy_90"
};